export default __webpack_public_path__ + "static/media/5555.1f864b5c.png";